import { StoryLineListType } from '@/types/cms/Storylines'
import styles from './StorylineListNumbered.module.scss'
import ArticleDetailDefault from '@/elements/widgets/Article/ArticleDetailDefault'
import AppContext from '@/types/context'

export default function StorylineListNumbered({
  item,
  context,
}: {
  readonly item: { model: StoryLineListType } | any
  readonly context: AppContext
}) {
  return (
    <ol className={styles.ol}>
      {item.model.related?.map((child: any) => (
        <li key={child.id}>
          <ArticleDetailDefault
            key={child.id}
            item={{ items: [{ model: child, type: child.type, id: child.id }] }}
            context={context}
          />
        </li>
      ))}
    </ol>
  )
}
